module.exports = __webpack_public_path__ + "static/gallery-8-76a09844e0e157f601a6d0a204cdfd10.jpg";